var React = require('react');

function Paragraph (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M368 96v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M432 48v32a16 16 0 0 1-16 16H272v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z","className":"fa-primary","key":2})]);
}

Paragraph.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Paragraph;

Paragraph.default = Paragraph;
